import { useListasModel } from '../../../modelos/listas/modeloListas';
import { useUsers } from '../../../metodos/userContext';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useTutoresModel } from '../../../modelos/Tutores/modeloTutores';
import PruebaEnCurso from './Prueba';
import { CheckCheck } from 'lucide-react';

const PresentarPrueba = () => {
  const { usuario , recargarUsuario} = useUsers();
  // Los estados y la lógica se mantienen igual
  const [step, setStep] = useState('inicio');
  const {
    examenesTutoresOptions,
    cargarExamenesTutores,
  } = useListasModel();
  const {
    generarPruebaProspectoLocal,
    updateTutor,
    entregarExamenPruebaProspecto,
  } = useTutoresModel();
  const [tiempoRestante, setTiempoRestante] = useState(null);

  //tiemp restante
  useEffect(() => {
    const fechaPresentacion = usuario?.examenAdmisionTutor?.fechaPresentacion;
    if (!fechaPresentacion) return;

    const fechaInicio = new Date(fechaPresentacion);
    const fechaExpiracion = new Date(fechaInicio.getTime() + 2 * 60 * 60 * 1000); // 2 horas después

    const intervalo = setInterval(() => {
        const ahora = new Date();
        const diferencia = fechaExpiracion - ahora;

        if (diferencia <= 0) {
            clearInterval(intervalo);
            setTiempoRestante({ horas: 0, minutos: 0, segundos: 0 });
            return;
        }

        const horas = Math.floor(diferencia / (1000 * 60 * 60));
        const minutos = Math.floor((diferencia % (1000 * 60 * 60)) / (1000 * 60));
        const segundos = Math.floor((diferencia % (1000 * 60)) / 1000);

        setTiempoRestante({ horas, minutos, segundos });
    }, 1000);

    return () => clearInterval(intervalo); // Limpieza al desmontar
  }, [usuario]);

  //opciones
  const [selectedOptions, setSelectedOptions] = useState([]); 
  const [error, setError] = useState(null);
  const handleSelectChange = (options) => {
      setSelectedOptions(options);
      if (error) setError(''); // Limpia el error si el usuario corrige
  };

  //archivos
  const [formData, setFormData] = useState({});

  const handleFinalizarPrueba = async () => {
      const totalExamenes = usuario.examenAdmisionTutor.examenes.length;
      const archivosCargados = Object.values(formData).filter(Boolean).length;

      if (archivosCargados < totalExamenes) {
        const confirmacion = window.confirm(
          'Oye, aún no has subido todos los archivos. ¿Deseas entregar la prueba de todas formas?'
        );
        if (!confirmacion) {
          return; 
        }
      }

      console.log("Entregando la prueba...", formData);

      // Tu lógica de subida está correcta y funcionará
      const respuestaSubida = await entregarExamenPruebaProspecto(usuario.uid, formData,usuario.examenAdmisionTutor.examenes);

      console.log("tenemos respuesta de subida",respuestaSubida);

      if(respuestaSubida){
        console.log("a ejecutar recargar usuario");
        await recargarUsuario();
      }
      
  };

  const handleGenerateTest = async () => {
      if (selectedOptions.length !== 3) {
        setError('Debes seleccionar exactamente tres materias.');
        return;
      }
      //materias
      const selectedSubjectsValues = selectedOptions.map(option => option.value);

      await generarPruebaProspectoLocal(selectedSubjectsValues,usuario.uid);

      recargarUsuario();
  };

  //comenzar prueba
  const comenzarPrueba = async () =>{
    await updateTutor(usuario.uid,'DUFY ASESORIAS','examenAdmisionTutor.fechaPresentacion',new Date(),'field');
    recargarUsuario();
    //prueba comenzada
  }

  //cargar pruebas
  useEffect(() =>{
    cargarExamenesTutores();
  }, []);

  // Contenedor principal que centra la tarjeta en la pantalla
  const MainContainer = ({ children }) => (
    <div className="bg-gray-100 min-h-screen flex items-center justify-center p-4">
      <div className="bg-white p-8 rounded-xl shadow-lg max-w-2xl w-full">

        {/* Contenedor para la información del perfil */}
        <div className="flex flex-col items-center mb-8">
          {/* Etiqueta <img> para mostrar la foto de perfil */}
          <img 
            src={usuario.fotoPerfil} 
            alt={`Foto de perfil de ${usuario.nombreCompleto}`} 
            className="w-24 h-24 rounded-full object-cover border-2 border-gray-200 shadow-md"
          />
          {/* Etiqueta para mostrar el nombre */}
          <h3 className="text-xl font-semibold text-gray-800 mt-4">
            {usuario.nombreCompleto}
          </h3>
        </div>

        {children}
      </div>
    </div>
  );

  if (usuario?.examenAdmisionTutor?.finalizado === true) {
        return (
            <MainContainer>
                <div className="text-center">
                    <CheckCheck />
                    <h2 className="text-3xl font-bold text-green-600 mb-4">Prueba Finalizada</h2>
                    <p className="text-gray-700 text-lg">Tu prueba ha sido entregada y guardada correctamente.</p>
                    <p className="text-gray-600 mt-2">Nuestro equipo la revisará pronto. ¡Gracias por tu tiempo!</p>
                </div>
            </MainContainer>
        );
  }

  //redenrizado si ya inicio examen
  if (usuario.examenAdmisionTutor.examenIniciado && usuario.examenAdmisionTutor.codigoPrueba !== "") {
    // Si el tiempo se acabó
    if (tiempoRestante && tiempoRestante.horas === 0 && tiempoRestante.minutos === 0 && tiempoRestante.segundos === 0) {
        return (
            <MainContainer>
                <div className="text-center">
                    <h2 className="text-3xl font-bold text-red-600 mb-4">⌛ ¡Tiempo Terminado!</h2>
                    <p className="text-gray-700">Tu prueba ha sido enviada para revisión.</p>
                </div>
            </MainContainer>
        );
    }
    // Si aún hay tiempo, mostramos la prueba
    if (tiempoRestante) {
        return (
            <div className="bg-gray-100 min-h-screen flex items-center justify-center p-4">
                <PruebaEnCurso 
                    tiempoRestante={tiempoRestante} 
                    onFinishTest={() => handleFinalizarPrueba()} 
                    examenes={usuario.examenAdmisionTutor.examenes}
                    formData={formData}
                    setFormData={setFormData}
                />
            </div>
        );
    }
    // Muestra un cargando mientras se calcula el tiempo inicial
    return <MainContainer><div>Cargando temporizador...</div></MainContainer>;
  }
    
  //prueba por generar

  //prueba ya generada
  if (usuario && usuario.examenAdmisionTutor && usuario.examenAdmisionTutor.codigoPrueba !== "") {
    return (
      <MainContainer>
        <div className="text-center">
          <h2 className="text-3xl font-bold text-green-600 mb-4">
            ✅ ¡Ya tienes una prueba generada!
          </h2>
          <p className="text-gray-700 mb-2">
            Tu código de prueba es: <strong className="font-mono bg-gray-200 px-2 py-1 rounded">{usuario.examenAdmisionTutor.codigoPrueba}</strong>
          </p>
          <p className="text-gray-700 mb-4">
            Tu prueba técnica fue creada para las siguientes materias:
          </p>
          <div className="inline-block text-left mb-6">
            {usuario.examenAdmisionTutor.examenes && usuario.examenAdmisionTutor.examenes.map(examen => 
              <p key={examen.materia} className="text-lg font-semibold text-gray-800"> • {examen.materia}</p>
            )}
          </div>
          <p className="text-gray-600">
            Recuerda que tienes <strong>1 semana</strong> para presentarla y una vez que inicies, tendrás <strong>2 horas</strong> para completarla.
          </p>
          <div className="mt-8">
            <button 
              onClick={() => {
                //comenzar prueba
                comenzarPrueba();
              }} 
              className="bg-green-600 text-white font-semibold py-3 px-8 rounded-lg hover:bg-green-700 transition-colors duration-300"
            >
              Comenzar Prueba Ahora
            </button>
          </div>
        </div>
      </MainContainer>
    );
  }

  if (step === 'inicio') {
    return (
      <MainContainer>
        <h2 className="text-3xl font-bold text-blue-600 text-center mb-6">
          Prueba técnica
        </h2>
        <p className="text-gray-700 mb-4 text-center">
          Para ser parte de nuestro equipo, debes presentar una prueba técnica. 
          Esta prueba tiene como objetivo medir tu nivel en <strong>tres materias que selecciones.</strong>
        </p>
        
        <div className="text-gray-600 space-y-2 mb-6">
            <p><strong>Duración de la prueba:</strong> 2 horas.</p>
            <p><strong>Número de preguntas:</strong> 3 preguntas.</p>
            <p><strong>Objetivo:</strong>Esta prueba tiene unicamente el objetivo de medir tu nivel, en 3 materias que selecciones, despues de abierta deberas resolverla.</p>
            <p><strong>Fecha de presentación:</strong> En el horario que elijas. Una vez comenzada, deberás completarla.</p>
            <p><strong>Fecha de expiración:</strong> 2 semanas después de generada.</p>
        </div>
        
        <p className="text-sm italic text-gray-500 mb-8 text-center">
          <strong>Nota:</strong> Una vez presentada, tu prueba será revisada por nuestro equipo. Si tienes cualquier problema o duda, no dudes en contactarnos.
        </p>

        <div className="text-center">
          <button 
            onClick={() => setStep('seleccion')} 
            className="bg-blue-600 text-white font-semibold py-3 px-8 rounded-lg hover:bg-blue-700 transition-colors duration-300"
          >
            GENERAR PRUEBA
          </button>
        </div>
      </MainContainer>
    );
  }
  
  if (step === 'seleccion') {
    
    return (
      <MainContainer>
        <h2 className="text-3xl font-bold text-blue-600 text-center mb-4">
          Instrucciones para generar prueba
        </h2>
        <p className="text-gray-700 mb-6 text-center">
          Selecciona las <strong>tres materias</strong> que mejor domines, solo 3 materias, no selecciones mas.
          Si dominas cosas relacionadas con  trabajos escritos, selecciona TRABAJOS y demas categorias..
        </p>
        
        <div className="mb-4">
          <label htmlFor="materias" className="block text-sm font-medium text-gray-700 mb-1">
            Agrega tus materias de una en una:
          </label>
          <Select
            isMulti // Habilita la selección múltiple
            options={examenesTutoresOptions} // Tu lista de materias
            value={selectedOptions} // El estado con las opciones seleccionadas
            onChange={handleSelectChange} // La función que actualiza el estado
            placeholder="Busca y selecciona tus 3 materias..."
            noOptionsMessage={() => "No se encontraron materias"}
            isOptionDisabled={() => selectedOptions.length >= 3}
            className="mb-4"
            classNamePrefix="select" 
          />
        </div>

        {error && <p className="text-red-600 text-sm text-center mb-4">{error}</p>}
        
        <div className="text-center mt-6">
          <button 
            onClick={handleGenerateTest} 
            className="bg-blue-600 text-white font-semibold py-3 px-8 rounded-lg hover:bg-blue-700 transition-colors duration-300 disabled:bg-gray-400"
            disabled={selectedOptions.length !== 3}
          >
            Generar Prueba
          </button>
        </div>

      </MainContainer>
    );
  }
  
  
  return null;
}

export default PresentarPrueba;